module.exports = __webpack_public_path__ + "static/img/ydyl4.af64328.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/ydyl4.jpg
// module id = YoQo
// module chunks = 0